import React, { useState } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Tooltip } from '~/components/_atoms'
import Modal from '~/components/_layouts/Modal'
import YnsIcon from '~/components/icons/YnsIcon'
import { Button } from '~/lib/ui/button'
import CoachChatAttachmentUpload from './CoachChatAttachmentUpload'

const CoachChatAttachmentModal = ({ candidateId, onAttachmentUploaded }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [uploadedAttachment, setUploadedAttachment] = useState(null)
  const { t } = useTranslation('coach_chat')

  const handleUploadSuccess = (attachmentData) => {
    // Keep the modal open and store the attachment data
    setUploadedAttachment(attachmentData)
  }

  const handleSendAttachment = () => {
    if (uploadedAttachment && onAttachmentUploaded) {
      onAttachmentUploaded(uploadedAttachment)
    }
    // Close the modal and reset state
    setIsOpen(false)
    setUploadedAttachment(null)
  }

  const handleClose = () => {
    setIsOpen(false)
    setUploadedAttachment(null)
  }

  const handleButtonClick = () => {
    setIsOpen(true)
  }

  return (
    <>
      {/* Attachment button — CTS-9777 / CC-UX-011 */}
      <Tooltip
        content={t('message_editor.attach_file', {
          defaultValue: 'Attach file',
        })}
        placement="top"
      >
        <Button
          variant="outline"
          size="sm"
          className="h-10 w-10 rounded-full p-0"
          disabled={!candidateId}
          onClick={handleButtonClick}
          title={t('message_editor.attach_file', {
            defaultValue: 'Attach file',
          })}
          aria-label={t('message_editor.attach_file', {
            defaultValue: 'Attach file',
          })}
        >
          <YnsIcon name="attachment" className="h-5 w-5" />
        </Button>
      </Tooltip>

      {/* Modal */}
      <Modal
        open={isOpen}
        onClose={handleClose}
        title={t('attachment.upload_attachment')}
        size="sm"
        variant="secondary"
        actions={
          <div className="flex w-full flex-row gap-2">
            <Button variant="outline" onClick={handleClose} className="flex-1">
              {t('common.cancel')}
            </Button>
            <button
              type="button"
              onClick={handleSendAttachment}
              disabled={!uploadedAttachment}
              className="h-10 flex-1 !cursor-pointer !items-center !justify-center !whitespace-nowrap !rounded-[20px] !bg-intoo-green-medium-700 !px-6 !py-2 !font-medium !text-white !ring-offset-background !transition-colors hover:!bg-intoo-green-medium-900 hover:!text-white focus:!text-white focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-ring focus-visible:!ring-offset-2 active:!text-white disabled:!pointer-events-none disabled:!opacity-50"
            >
              <div className="yns-stack flex flex-row flex-wrap items-center gap-2">
                <span className="btn-label">{t('common.send')}</span>
              </div>
            </button>
          </div>
        }
      >
        <CoachChatAttachmentUpload
          candidateId={candidateId}
          onUploadSuccess={handleUploadSuccess}
        />
      </Modal>
    </>
  )
}

export default CoachChatAttachmentModal
